export default {
  s: '%d ثانیه',
  smicro: '%d ث',
  smid: '%d ثانیه',

  ss: '%d ثانیه',
  ssmicro: '%d ث',
  ssmid: '%d ثانیه',

  m: '%d دقیقه',
  mmicro: '%d د',
  mmid: '%d دق',

  mm: '%d دقیقه',
  mmmicro: '%d د',
  mmmid: '%d دق',

  h: '%d ساعت',
  hmicro: '%d س',
  hmid: '%d ساعت',

  hh: '%d ساعت',
  hhmicro: '%d س',
  hhmid: '%d ساعت',

  d: '%d روز',
  dmicro: '%d ر',
  dmid: '%d روز',

  dd: '%d روز',
  ddmicro: '%d ر',
  ddmid: '%d روز',
};
